goog.provide('el8.appchart.dialog.visitNoteEdit');

goog.require('el8.service.tz');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.dialog.visitNoteEdit');
goog.require('el8.appchart.showItemDetail');

el8.appchart.dialog.visitNoteEdit = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'View Changes in Amended Visit Note',
        autoHeight: true,
        width: 800,
        position: 'center',
        showXButton: true
    });

    function getContent(note, editId) {
        var data = el8.ptdata.model.note.asSoyMap(note, editId);
        var edit = note.getEditById(editId);
        // add metadata on this particular edit details?
        data['feedItemId'] = 'edits_'+note.getFeedItemId();
        data['isEdit'] = true;
        data['editSignDate'] = el8.service.tz.soyStr(edit.getSignDate());
        if (edit.getNewNoteTime()) {
            data['newDocumentDate'] = el8.service.tz.soyStr(edit.getNewNoteTime());
            data['replacedDocumentDate'] = el8.service.tz.soyStr(edit.getPreviousNoteTime());
        }
        if (edit.getNewNoteTypeId()) {
            data['newDescription'] = note.getDescription(edit.getNewNoteTypeId());
            data['replacedDescription'] = note.getDescription(edit.getPreviousNoteTypeId());
        } // else, just use description already from asSoyMap
        if (edit.getNewPrevWeight()) {
            data.objective.vitals.prevVitals['newWeight'] = edit.getNewPrevWeight();
            data.objective.vitals.prevVitals['replacedWeight'] = edit.getPreviousPrevWeight();
        }
        if (edit.getNewPrevBmi()) {
            data.objective.vitals.prevVitals['newBmi'] = edit.getNewPrevBmi();
            data.objective.vitals.prevVitals['replacedBmi'] = edit.getPreviousPrevBmi();
        }
        if (edit.getNewPrevTime()) {
            data.objective.vitals.prevVitals['newTime'] = el8.service.tz.soyStr(edit.getNewPrevTime());
            data.objective.vitals.prevVitals['replacedTime'] = el8.service.tz.soyStr(edit.getPreviousPrevTime());
        }
        if (edit.getNewBmi()) {
            data.objective.vitals['newBmi'] = edit.getNewBmi();
            data.objective.vitals['replacedBmi'] = edit.getPreviousBmi();
        }
        return el8.template.appchart.dialog.visitNoteEdit.content(data);
    }

    function loadImages(note) {
        if (note.getImages().length) {
            el8.util.feed.loadImages({
                item: note,
                images: note.getImages(),
                container: that.getContentElt(),
                width: 800
            });
        }
    }

    var super_show = that.show;
    that.show = function(note, editId) {
        super_show.call(that);
        that.setContent(getContent(note, editId));
        loadImages(note);
        that.adjustPosition();
    };

    return that;

})();

